// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"172":"6676784a","511":"713f10cd","673":"8330fb01"}[chunkId] + ".chunk.js");